import loginService from '../../services/servicesLogin';

const resetState = () => dispatch => {
  dispatch({
    type: 'gto/SET_SUMMARY',
    payload: { glosaCount: 0 }
  });

  dispatch({
    type: 'gto/FETCH_DATA',
    payload: { gtosList: [], loading: false }
  });

  dispatch({
    type: 'plans/OVERWRITE',
    payload: {
      plans: { list: [], details: {} },
      procedures: { types: [], details: {} }
    }
  });

  dispatch({ type: 'procedure/CLEAN' });
};

export const logout = () => dispatch => {
  dispatch({
    type: 'SET_LOGOUT',
    payload: null
  });

  dispatch(resetState());
};

export const authenticate = ({ cpf, password, isCpfCnpj }) => dispatch => {
  dispatch({ type: 'user/LOADING' });
  
  return loginService
    .loginAPI(cpf, password, isCpfCnpj)
    .then(data => {
      dispatch(resetState());

      dispatch({
        type: 'user/SET_USER',
        payload: data
      });

      return Promise.resolve(data);
    })
    .catch(({ message }) => Promise.reject(new Error(message)));
};
